<template>
    <!-- 联系方式 -->
    <div class="contaier">
        <!-- <Title-b title="sss"> -->
        <Title-b title="联系方式" />
        <!-- <p class="p">联系方式</p> -->
        <div class="total">
            <!-- <div class="upper">
                <div class="left"><img src="../../../assets/images/4.jpg" alt=""></div>
                <div class="right">
                    <div><img src="../../../assets/images/dianhua.png" alt=""/><span>联系方式</span></div>
                    <ul style="margin-top:20px;">
                        <li>全国业务咨询热线：{{allorder.Phone}}</li>
                        <li>技术支持：{{allorder.Phone}}</li>
                        <li>企业QQ：{{allorder.QQ}}</li>
                    </ul>
                </div>
            </div>
            <div class="lower">
                <div class="left"><img src="../../../assets/images/4.jpg" alt=""></div>
                <div class="right">
                    <div><img src="../../../assets/images/dianhua.png" alt=""/><span>联系方式</span></div>
                    <ul style="margin-top:20px;">
                        <li>公司地址：解放路口的荆防颗粒</li>
                        <li>邮编：1215151515</li>
                        <li>公司网址：<span>{{allorder.MainUrl}}</span></li>
                    </ul>
                </div>
            </div> -->
            <div v-for="(item,index) in List" :key="index">
                <div style="margin: 10px 20px;">
                    <p v-if="item.Type == 0">在线QQ</p>
                    <p v-else>在线旺旺</p>
                    <p>{{item.Name}}</p>
                    <div v-if="item.Type == 0" class="qqContact" @click="toQQ(item.No)">
                        <img src="../../../assets/images/button_old_41.gif" />
                        <span>QQ交谈</span>
                    </div>
                    <div v-else class="wangContact" @click="toWangWang(item.No)">
                        <img src="../../../assets/images/wangwang.jpeg" style="width: 23px;vertical-align: bottom;"/>
                        <span>和我联系</span>
                    </div>
                </div>
            </div>
        </div>
        <img :src="wechatImg" class="wechat"/>
    </div>
</template>
<script>
import md5 from "js-md5";
export default {
    data(){
        return{
            allorder:[],
            List: [],
            QQandAliWW: [],
            wechatImg: ""
        }
    },
    mounted(){
        this.queryUrl();
        this.getShopImg()
    },
    methods:{

        async getShopImg() {
            let JsonData = { ImgType: 1 }
            const { data } = await this.$post('/GetShopImg', JsonData)
            if(data.State) {
                let url = JSON.parse(data.ReturnJson)[0]
                this.wechatImg = 'http://8.134.13.247:8890'+ url.ImageUrl
            }
        },

        toQQ(No) {
            window.open(`tencent://message/?uin=`+No+`&Site=在线QQ&Menu=yes`, '_blank')
        },
        toWangWang(No) {
            window.open(`http://www.taobao.com/webww/ww.php?ver=3&touid=`+No+`&siteid=cntaobao&status=1&charset=utf-8`, '_blank')
        },
        async queryUrl() {
            var JsonData = {
                Url: "member.anto1688.com",
            };
            const { data } = await this.$post("/QueryUrl", JsonData);
            if (data.State) {
                this.allorder = JSON.parse(data.ReturnJson);
                this.List = JSON.parse(data.ReturnJson).QQandAliWW;
            }

            // const _md5 = md5('{"Url":"member.dellker.com"}123456');
            // const params = {
            //     JsonData: '{"Url":"member.dellker.com"}',
            //     CusID: "23",
            //     KeyMd5: _md5,
            //     Url:'{"Url":"member.dellker.com"}'
            // };
            // const { data } = await this.$post("/QueryUrl", params, true);
            // if (data.State) {
            //       this.allorder = JSON.parse(data.ReturnJson);
            //     // localStorage.setItem("CusID", storeInfo.CusID);
            //     // localStorage.setItem("shopName", storeInfo.Name);
            //     // localStorage.setItem("KeyText", storeInfo.KeyText);
            //     // localStorage.setItem("phone", storeInfo.Phone);
            // }
        },
    }
}
</script>
<style lang="scss" scoped>
    .qqContact {
        background: #9fd8f5;
        width: 90px;
        padding: 2px 5px;
        border-radius: 4px;
        border: 1px solid #6bbfee;
        img {
            vertical-align: middle;
        }
    }

    .wangContact {
        background-image: linear-gradient(#ffffff,#fef073);
        width: 90px;
        padding: 0px 5px;
        color: #de6646;
        border: 1px solid #ff9739;
        border-radius: 4px;
    }
    
    .wechat {
        width: 300px;
    }
    .contaier{
        width: 1069px;
        height: 691px;
        border-radius: 5px;
        background: #fff;
        padding: 19px 17px;
        // .p{
        //     padding: 19px 17px;
        //     color:#000;
        // }
        .total{
            display: flex;
            .upper{
                display: flex;
                flex-direction: row;
                margin: 40px 0 0 105px;
                .left{
                    width: 256px;
                    height: 169px;
                    background: #000;
                }
                .right{
                    margin: 15px 0 0 50px;
                    > div{
                        border-bottom: 1px dashed #c2c2c2;
                        height: 28px;
                        width:218px;
                        img{vertical-align: middle;}
                        span{vertical-align: middle;margin: 0 0 0 20px;}
                    }
                    ul li{
                        margin: 8px 0;
                        color: #999;
                        list-style: none;
                        span{
                            text-decoration: underline;
                            color: red;
                        }
                    }
                }
            }
            .lower{
                display: flex;
                flex-direction: row;
                margin: 78px 0 0 105px;
                .left{
                    width: 256px;
                    height: 169px;
                    background: #000;
                }
                .right{
                    margin: 15px 0 0 50px;
                    > div{
                        border-bottom: 1px dashed #c2c2c2;
                        height: 28px;
                        width: 218px;
                        img{vertical-align: middle;}
                        span{vertical-align: middle;margin: 0 0 0 20px;}
                    }
                    ul li{
                        margin: 8px 0;
                        color: #999;
                        list-style: none;
                        cursor: pointer;
                        span{
                            text-decoration: underline;
                            color: red;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/view/memberservices/contact.vue